import Icon from '../../../ui-kit/components/atoms/Icon'
import {CROSS_ICON} from '../../../ui-kit/helpers/icons/cross'

const DeleteButton = ({onClick, title}) => {
  return (
    <button onClick={onClick} title={title} className="delete-button">
      <Icon svg={CROSS_ICON} />
    </button>
  )
}

export default DeleteButton
